export const meta = {
  title: '排队看板:告别白板,管好队伍',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'pos', 'staff'],
};

排队看板是后台的心脏。它在每台打开它的设备上实时同步——收银台、洗车工的平板、您的手机。

## 三个栏目

每张进行中的洗车单都处于三栏之一:

- **排队中**——已下单,等待洗车位。单子上显示排队位置。
- **清洗中**——正在清洗。
- **待取车**——已洗好,等顾客付款取车。

每张卡片显示单号、套餐、车牌和金额。排队栏空了就没什么要管的——顾客一扫您的二维码,新单立刻出现。

## 「下一辆」按钮

**下一辆**按钮位于「排队中」一栏的顶部,始终标着队首那张单子的单号。点一下,那张单子就进入清洗。如果洗车工只想记住一个按钮,就是它。

您也可以直接点某张卡片上的**开始**,让特定车辆先洗——作用相同,只是不必是队首。

## 调整队伍顺序

「排队中」一栏的每张卡片左侧都有**上下箭头**。每点一次,单子移动一位。顾客应用里的排队位置即刻更新。

没有拖拽调序——在沾水的平板上,精准的单点胜过误触的拖动。

## 挂起与恢复

顾客下了单却跑去吃午饭?点卡片上的**挂起**。单子离开队伍,停进「排队中」一栏底部的**挂起区**,后面的车自动前移。

顾客回来后点**恢复**。单子重新入队,排在**队尾**——不是原来的位置。想给它优先,就用上箭头往前调。这是有意为之:一直排着队的人,不该悄无声息地被插队。

## 完成、取车、取消

- **完成**把清洗中的单子移到待取车,并通知顾客车已洗好。
- **取车**是最后一步——单子归档进历史,报表和会员系统由此接手。付款在收银(POS)页面确认。
- **取消**在排队中、清洗中或挂起时可用。已进入待取车的单子不能在看板上取消——请到收银台结清。

## 多家门店?

看板顶部的**门店切换器**可在各门店间切换整个视图。每家门店有自己的队伍、自己的二维码、自己的单号。

## 顾客看到什么

您在看板上的每一步操作都会同步到顾客的应用里。他们能看到自己的排队位置,并在每个节点收到通知——入队时、开洗时、车洗好时,以及您挂起或取消他们的单子时。再也不用隔着场地喊车牌了。
